import {
  createContext,
  createElement,
  useContext,
  type ReactNode,
} from 'react';
import type { PlanType } from '@/store/useAuthStore';

export type PaidEntitlementBridgeSource = 'none' | 'accountContract';
export type PaidEntitlementBridgePlan = Exclude<PlanType, 'free'>;

export interface PaidEntitlementBridgeValue {
  isPaidOwner: boolean;
  effectivePlan: PaidEntitlementBridgePlan;
  source: PaidEntitlementBridgeSource;
}

const DEFAULT_BRIDGE: PaidEntitlementBridgeValue = {
  isPaidOwner: false,
  effectivePlan: 'light',
  source: 'none',
};

const PaidEntitlementBridgeContext =
  createContext<PaidEntitlementBridgeValue>(DEFAULT_BRIDGE);

export function PaidEntitlementBridgeProvider({
  value,
  children,
}: {
  value: PaidEntitlementBridgeValue;
  children: ReactNode;
}) {
  return createElement(
    PaidEntitlementBridgeContext.Provider,
    { value },
    children
  );
}

export function usePaidEntitlementBridge(): PaidEntitlementBridgeValue {
  return useContext(PaidEntitlementBridgeContext);
}

export function applyPaidEntitlementBridgeToPlan(
  currentPlan: PlanType,
  bridge: PaidEntitlementBridgeValue
): PlanType {
  if (bridge.isPaidOwner && currentPlan === 'free') {
    return bridge.effectivePlan;
  }
  return currentPlan;
}
